import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, BACKGROUND_SIDE_BAR } from '../../../globals';

export const StyledCategoryDropDown = styled.div`
  margin: ${PADDING_CONTENT_PAGE}px;
  border-radius: 2px;
  background-color: ${props => props.isOpen ? BACKGROUND_SIDE_BAR : '#e3e3e3' };

  .category-dd-title-wrapper {
    cursor: pointer;
    ${props => props.isOpen ? 'color: white;' : '' }
    background-color: ${props => props.isOpen ? BACKGROUND_SIDE_BAR : '#e3e3e3' };
    padding: 10px;
  }
  
  .category-dd-table {
    width: 100%;
    table-layout:fixed;
    min-height: 2.8em;
    height: 2.8em;
    line-height: 1.4em;
  }

  .category-dd-title {
    font-weight: bold;
    font-size: 1em;
    word-break: normal;
  }

  .category-dd-title-wrapper:hover{
    background-color: ${BACKGROUND_SIDE_BAR};
    color: white;
    border-radius: 2px;
  }

  .category-dd-arrow {
    width: 25px;
    text-align: center;
    vertical-align: middle;
    font-size: 1em;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


  .category-dd-items {

  }

  :focus {
    
  }

`;
